<template>
  <div>
    <div v-if="isFirstScreen">
      <h1 class="has-text-centered is-size-2 mb-5">{{ this.$utils.getOwner().name }}</h1>
      <div v-for="(value, key, idx) in data" :key="idx">
        <div class="columns" v-html="formatValue(value)"></div>
      </div>
    </div>
    <div v-else>
      <h1 class="has-text-centered is-size-2 mb-5">חריגות זמנים של {{ this.$utils.getOwner().name }}</h1>
      <div>
        <table class="table">
          <thead>
            <tr>
              <th>Created At</th>
              <th>Resource</th>
              <th>Content</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="stat in displayStats" :key="stat.id">
              <td>{{ $moment(stat.created_at).format('DD/MM/YYYY') }}</td>
              <td class="is-flex">
                <LinkEntity :payload="stat.resources.applicant" />
                <LinkEntity :payload="stat.resources.position" :additional_data="{ resource_type: 'Position' }" />
                <LinkEntity :payload="stat.resources.company" />
              </td>
              <td>{{ stat.content }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="modal_footer is-justify-content-space-evenly">
      <a @click="submit" class="button is-info">אישור</a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LinkEntity from '@/components/LinkEntity'

export default {
  name: 'ModalDailySummary',
  components: {
    LinkEntity
  },
  props: {
    payload: {
      type: Object,
      default: () => ({})
    },
    isFirstScreen: {
      type: Boolean,
      default: false
    },
    onSubmit: {
      type: Function,
      default: () => {}
    }
  },
  data () {
    return {
      displayStats: [],
      adminRequirments: {},
      data: {
        offers_sent: {
          id: 1,
          value: 0,
          label: 'מספר שליחות יומי',
          failCriteria: 'dailySentValue'
        },
        accurate_send: {
          id: 2,
          value: 0,
          label: 'מספר שליחות שהתקדמו היום'
        },
        applicant_answered_phone: {
          id: 3,
          value: 0,
          label: 'מספר שיחות שביצעת למועמדים',
          failCriteria: 'dailyPhoneCallsValue'
        },
        time_exceed: {
          id: 4,
          value: 0,
          label: 'מספר משימות שחרגת בזמנים',
          failCriteria: 10
        },
        daily_breaks: {
          id: 5,
          value: 0,
          label: 'זמן ההפסקה היומי',
          failCriteria: 46
        },
        follow_up: {
          id: 6,
          value: 0,
          label: 'מספר פולואפס יומי',
          failCriteria: 'dailyFollowUpsValue'
        },
        offers_vesting: {
          id: 7,
          value: 0,
          label: 'מספר השמות יומי'
        }
      }
    }
  },
  computed: {
    ...mapGetters('settings', ['getDailySentValue', 'getDailyPhoneCallsValue', 'getDailyFollowUpsValue']),
    dailySentValue () {
      console.log(this.adminRequirments.daily_sent)
      return this.adminRequirments.daily_sent || this.getDailySentValue
    },
    dailyPhoneCallsValue () {
      return this.adminRequirments.daily_phone_calls || this.getDailyPhoneCallsValue
    },
    dailyFollowUpsValue () {
      return this.adminRequirments.daily_follow_ups || this.getDailyFollowUpsValue
    }
  },
  created () {
    this.getInformation()
  },
  methods: {
    async submit () {
      if (this.isFirstScreen) {
        this.isFirstScreen = false
        localStorage.setItem('logout', this.isFirstScreen)
        await this.getStats()
      } else {
        this.onSubmit(this.payload.modal_id)
      }
    },
    formatValue (value) {
      if ([1, 3, 6].includes(value.id)) {
        if (value.value < this[value.failCriteria]) {
          return `<div class="column has-text-centered has-text-danger">${value.label} ☹️</div><div class="column has-text-danger">${value.value || 0}</div>`
        } else {
          return `<div class="column has-text-centered has-text-success">${value.label} 🏆</div><div class="column has-text-success">${value.value || 0}</div>`
        }
      }
      if ([4, 5].includes(value.id) && value.value > value.failCriteria) {
        return `<div class="column has-text-centered has-text-danger"> ☹️ ${value.label}</div><div class="column has-text-danger">${value.value || 0}</div>`
      }
      return `<div class="column has-text-centered">${value.label}</div><div class="column">${value.value || 0}</div>`
    },
    async getInformation () {
      const res = await this.$network_utils.getAdminRequirments({ admin_id: this.$utils.getOwner().id })
      this.adminRequirments = res.length ? res[0] : {}
      console.log(this.adminRequirments)
      if (!this.isFirstScreen) {
        await this.getStats()
      } else {
        const data = await this.$network_utils.getFeedReport({
          owner: this.$utils.getOwner().name,
          date_from: this.$moment().startOf('day').toString(),
          date_to: this.$moment().endOf('day').toString()
        })
        Object.keys(data).forEach(e => {
          if (this.data[e]) {
            this.data[e].value = data[e][this.$utils.getOwner().name]
          }
        })
      }
    },
    async getStats () {
      this.displayStats = await this.$network_utils.getStats({
        owner: this.$utils.getOwner().name,
        designator: 'time_exceeded_alert',
        date_from: this.$moment().startOf('day').toString(),
        date_to: this.$moment().endOf('day').toString(),
        sort: '-id'
      })
    }
  }
}
</script>
